import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminWidgetComponent } from './admin-widget.component';

const routes: Routes = [
  {
    path: '',
    component: AdminWidgetComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminWidgetRoutingModule {}
